// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.carousel-arrows[data-v-e3c851e2] {

    pointer-events: none;

    position: absolute;

    z-index: 10;

    display: flex;

    height: 100%;

    width: 100%;

    align-items: center;

    justify-content: space-between;

    -moz-column-gap: 0.75rem;

         column-gap: 0.75rem;

    padding: 1.5rem
}
.carousel-arrows.horizontal[data-v-e3c851e2] {

    flex-direction: row
}
.carousel-arrows.vertical[data-v-e3c851e2] {

    flex-direction: column
}
.carousel-arrows.start[data-v-e3c851e2] {

    justify-content: flex-start
}
.carousel-arrows.end[data-v-e3c851e2] {

    justify-content: flex-end
}
.carousel-arrows-icon[data-v-e3c851e2] {

    pointer-events: auto;

    cursor: pointer;

    opacity: 0.8;

    transition-property: all;

    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

    transition-duration: 150ms
}
.carousel-arrows-icon[data-v-e3c851e2]:hover {

    opacity: 1
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/carousels/CarouselArrows.vue"],"names":[],"mappings":";AA2FA;;IAAA,oBAAA;;IAAA,kBAAA;;IAAA,WAAA;;IAAA,aAAA;;IAAA,YAAA;;IAAA,WAAA;;IAAA,mBAAA;;IAAA,8BAAA;;IAAA,wBAAA;;SAAA,mBAAA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAIA;;IAAA;AAAA;AAIA;;IAAA;AAAA;AAIA;;IAAA;AAAA;AAIA;;IAAA,oBAAA;;IAAA,eAAA;;IAAA,YAAA;;IAAA,wBAAA;;IAAA,wDAAA;;IAAA;AAAA;AAGA;;IAAA;AAAA","sourcesContent":["<template>\n  <div\n    :class=\"[\n      'carousel-arrows',\n      orientation,\n      {\n        start: value === count - 1 && !loop,\n        end: value === 0 && !loop,\n      },\n    ]\"\n  >\n    <IconButton\n      v-if=\"value > 0 || loop\"\n      :name=\"orientation === 'horizontal' ? 'chevron-left' : 'chevron-up'\"\n      :size=\"36\"\n      type=\"outline\"\n      :color=\"color\"\n      class=\"carousel-arrows-icon\"\n      @click.native=\"handlePrevious\"\n    />\n    <IconButton\n      v-if=\"value < count - 1 || loop\"\n      :name=\"orientation === 'horizontal' ? 'chevron-right' : 'chevron-down'\"\n      :size=\"36\"\n      type=\"outline\"\n      :color=\"color\"\n      class=\"carousel-arrows-icon\"\n      @click.native=\"handleNext\"\n    />\n  </div>\n</template>\n\n<script>  \nimport IconButton from '@/lego/components/buttons/IconButton.vue';\nimport { toRefs } from '@vue/composition-api';\n\nexport default {\n  components: { IconButton },\n\n  props: {\n    value: {\n      type: Number,\n      required: true,\n    },\n\n    count: {\n      type: Number,\n      default: 0,\n    },\n\n    orientation: {\n      type: String,\n      default: 'horizontal',\n    },\n\n    color: {\n      type: String,\n      default: 'white',\n    },\n\n    loop: {\n      type: Boolean,\n      default: false,\n    },\n  },\n  setup(props, { emit }) {\n    const { value, count, orientation, color, loop } = toRefs(props);\n\n    const handlePrevious = () => {\n      if (value.value > 0) {\n        emit('input', value.value - 1);\n      } else if (loop.value) {\n        emit('input', count.value - 1);\n      }\n    };\n\n    const handleNext = () => {\n      if (value.value < count.value - 1) {\n        emit('input', value.value + 1);\n      } else if (loop.value) {\n        emit('input', 0);\n      }\n    };\n\n    return { handlePrevious, handleNext };\n  },\n};\n</script>\n\n<style scoped lang=\"postcss\">\n.carousel-arrows {\n  @apply w-full h-full absolute flex justify-between items-center z-10 p-xxs gap-x-micro pointer-events-none;\n\n  &.horizontal {\n    @apply flex-row;\n  }\n\n  &.vertical {\n    @apply flex-col;\n  }\n\n  &.start {\n    @apply justify-start;\n  }\n\n  &.end {\n    @apply justify-end;\n  }\n\n  &-icon {\n    @apply cursor-pointer transition-all opacity-80 pointer-events-auto;\n\n    &:hover {\n      @apply opacity-100;\n    }\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
